<app-header title="Subscription"></app-header>
<section class="subscription">
  <h3 class="subscription__title">My subscriptions management</h3>
  <div class="subscription__content">
    <div class="subscription__table">
      <div class="subscription__thead">
        <div class="subscription__th">Name</div>
        <div class="subscription__th">Term</div>
        <div class="subscription__th">Price</div>
        <div class="subscription__th">Status</div>
      </div>
      <div *ngIf="isSubscriptionsLoading; else subscriptionsTableBody" class="subscription__tbody">
        <div class="subscription__tr" *ngFor="let row of skeletonRows">
          <div class="skeleton subscription__td-skeleton"></div>
          <div class="skeleton subscription__td-skeleton"></div>
          <div class="skeleton subscription__td-skeleton"></div>
          <div class="subscription__check-flag"></div>
        </div>
      </div>

      <ng-template #subscriptionsTableBody>
        <div class="subscription__tbody">
          <div
            class="subscription__tr"
            [class.active]="currentSubscriptionId === subscription.id && !isSubscriptionExpired"
            [class.subscription__tr_selected]="activeSubscriptionId === subscription.id"
            [class.subscription__tr_disabled]="currentSubscriptionId === subscription.id"
            (click)="selectSubscription(subscription.id)"
            *ngFor="let subscription of visibleSubscriptions"
          >
            <div class="subscription__td">{{ subscription.name }}</div>
            <div class="subscription__td">{{ subscription.duration }}</div>
            <div class="subscription__td">${{ subscription.price }}</div>
            <div class="subscription__td" class="subscription__check-flag">
              <img src="assets/img/icons/selected.svg" alt="" />
            </div>
          </div>
        </div>
      </ng-template>
    </div>
    <div>
      <button
        *ngIf="isNoSubscription"
        [disabled]="activeSubscriptionId === 0"
        (click)="openChangePopup()"
        class="subscription__btn btn btn_primary"
      >
        Buy new subscription
      </button>

      <button
        *ngIf="!isNoSubscription"
        [disabled]="activeSubscriptionId === 0"
        (click)="openChangePopup()"
        class="subscription__btn btn btn_primary"
      >
        Change subscription
      </button>
      <!-- <img class="subscription__refresh_btn" (click)="ngOnInit()" src="assets/img/icons/refresh.svg" alt="refresh"> -->
      <!-- <button class="btn btn_naked subscription__check-btn">Check subscription</button> -->
    </div>
  </div>
</section>
<app-change-subscription-modal
  [fromSubject]="changingFromSubjectText"
  [toSubject]="changingToSubjectText"
  (submit)="selectNewSubscriptionPlan()"
></app-change-subscription-modal>

<app-missing-subscription-error-modal
  [modalName]="unpaidExtraPagesModal"
  title="Pay for extra pages first"
  text="To switch to a new plan, pay for your extra pages."
  buttonText="Pay"
  (chooseNumber)="payExtraPages()"
></app-missing-subscription-error-modal>

<app-error-modal [message]="errorMessage"></app-error-modal>
